<template>
  <div class="comment-add">
    <!-- 标题 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"  :close-on-press-escape="false">
      <el-form size="small" :model="form" ref="form">

        <el-form-item label="积分规则" prop="cate_id" :label-width="formLabelWidth">
          <el-select v-model="form.cate_id" placeholder="请选择" filterable clearable>
            <el-option label="不限" value=""></el-option>
            <el-option v-for="(v, i) in tableData" :key="i" :label="v.title+'(+'+v.point+'分)'" :value="v.cate_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="用户ID" prop="user_id" :label-width="formLabelWidth" :rules="[{ required: true, message: '请选择用户ID' }]">
          <el-input type="text" v-model="form.user_id" autocomplete="off" class="max-w260">
          <el-button slot="append" type="primary" icon="el-icon-user-solid" @click="openUserDialog" >选择用户</el-button>
          </el-input>
        </el-form-item>

        <el-form-item label="状态" prop="status" :label-width="formLabelWidth">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">申请中</el-radio>
            <el-radio :label="2">已审核</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button  type="primary" @click="save" :loading="loading">确 定</el-button>
      </div>

    </el-dialog>

    <!--上传图片组件-->
    <Upload v-if="is_upload" :isupload="is_upload" @returnImgs="returnImgsFunc">上传图片</Upload>

    <!--用户选择-->
    <GetUser :is_open="open_user" @close="closeUserDialog"></GetUser>
    
  </div>
</template>

<script>
  import PointsApplyApi from '@/api/study/points_apply.js';
  import PointsCateApi from '@/api/study/points_cate.js';
  import Upload from '@/components/file/Upload';
  import GetUser from '@/components/user/GetUser.vue';
  export default {
    components: {
      Upload,
      GetUser
    },
    data() {
      return {
        // 类型
        type:'add',  // add:添加  edit:编辑 dateil:详情
        title:'添加',

        //需要提交的表单
        form: {
          cate_id: '',
          user_id: '',
          status: 2,
        },

        tableData: [],
        open_user: false,
        
        /*左边长度*/
        formLabelWidth: '100px',
        /*是否显示*/
        dialogVisible: false,//是否展示
        //加载
        loading: false,
        /*是否上传图片*/
        is_upload: false,
        img_index: '',
      };
    },
    props: ['is_open', 'oneform'],//open_add 是否展示
    created() {
      this.getData();

      //数据赋值
      this.type = this.oneform.type;

      //类型
      if(this.type == 'edit' || this.type == 'dateil' || this.type == 'audit'){
        if(this.type == 'audit' ){
          this.title = '审核';
        }else if(this.type == 'edit' ){
          this.title = '编辑';
        }else{
          this.title = '详情';
        }
        //赋值
        this.form = this.oneform.model;
        if (!this.form.apply_id) this.form.apply_id = '';
      }

      //是否展示
      this.dialogVisible = this.is_open;
      
    },
    methods: {
      /*获取列表*/
      getData() {
        let self = this;
        PointsCateApi.getList({is_page: 0}, true).then(data => {
          self.loading = false;
          self.tableData = data.data.list;
        }).catch(error => {

        });
      },
      /*保存*/
      save() {
        let self = this;
        let params = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            if(self.type == 'audit'){
              PointsApplyApi.audit(params).then(data => {
                self.loading = false;
                self.$message({
                  message: '审核成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);
              }).catch(error => {
                self.loading = false;
              });
            }else if(self.type == 'add'){
              PointsApplyApi.add(params).then(data => {
                self.loading = false;
                self.$message({
                  message: '添加成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);
              }).catch(error => {
                self.loading = false;
              });
            }else if(self.type == 'edit'){
              PointsApplyApi.edit(params).then(data => {
                self.loading = false;
                self.$message({
                  message: '添加成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);
              }).catch(error => {
                self.loading = false;
              });
            }
          }
        })
      },

      /*打开用户弹窗*/
      openUserDialog() {
        this.open_user = true;
      },

      /*关闭用户弹窗*/
      closeUserDialog(e) {
        if (e.type != 'error') {
          this.user = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_user = false;
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

      /*上传*/
      openUpload(e) {
        this.img_index = e;
        this.is_upload = true;
      },

      delImg(){
        this.form.icon = '';
        this.form.icon_id = '';
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null) {
          if (this.img_index == 1000){
            this.form.icon = e[0].file_path;
            this.form.icon_id = e[0].file_id;
          }else{
            this.customField[this.img_index].image = e[0].file_path;
            this.customField[this.img_index].image_id = e[0].file_id;
          }
        }
        this.is_upload = false;
      },

    }
  };
</script>




// WEBPACK FOOTER //
// src/views/user/points/part/part/AddPoint.vue